// Generated automatically by nearley, version 2.20.1
// http://github.com/Hardmath123/nearley
function id(x) { return x[0]; }


import moo from 'moo'

// "The order of your rules matters. Earlier ones will take precedence." - for an JS object that sounds not very reliable.
// "Only rules from the current state can be matched. You need to copy your rule into all the states you want it to be matched in."
// From: https://github.com/no-context/moo#states
const sts = {}

function applyTemplate(rule, tpl) {
	if (tpl) {
		for (const [key, value] of Object.entries(tpl)) {
			rule[key] = value
		}
	}
}

const rxWsAtEnd = new RegExp('\\s+\$', 'g')
function wsTrimAtEnd(str) {
	return str.replace(rxWsAtEnd, '')
}
const rxOptWsAtEnd = new RegExp('\\s*\$', 'g')
function convStr(str) {
	return str.replace(rxOptWsAtEnd, '').slice(1, -1)
}
function k(ruleKey, key, tpl) {
	const cnst = key.toLowerCase()
	try {
		if (!sts[ruleKey]) sts[ruleKey] = {}
		sts[ruleKey][key] = {
			match: new RegExp(key+'[ \t\n]*'),
			lineBreaks: true,
			value: str => cnst
		}
		applyTemplate(sts[ruleKey][key], tpl)
	} catch(err) {
		throw new Error(`Problem creating key rule '${key}'->'${cnst}': ${err.message}`, err)
	}
}
function c(ruleKey, key, cnst, tpl) {
	try {
		if (!sts[ruleKey]) sts[ruleKey] = {}
		sts[ruleKey][key] = {
			match: new RegExp(cnst+'[ \t\n]*'),
			lineBreaks: true,
			value: str => cnst
		}
		applyTemplate(sts[ruleKey][key], tpl)
	} catch(err) {
		throw new Error(`Problem creating const rule '${cnst}': ${err.message}`, err)
	}
}
function p(ruleKey, key, pattern, tpl) {
	try {
		if (!sts[ruleKey]) sts[ruleKey] = {}
		sts[ruleKey][key] = {
			match: new RegExp(pattern+'[ \t\n]*'),
			lineBreaks: true,
			value: str => wsTrimAtEnd(str)
		}
		applyTemplate(sts[ruleKey][key], tpl)
	} catch(err) {
		throw new Error(`Problem creating pattern rule '${pattern}': ${err.message}`, err)
	}
}

const STT_EXPR = 'main' // for where and assignment
const STT_EXPR_UPPER_LEVEL = 'main_upper_level' // for bound_spec
function exprSs(lcl = STT_EXPR_UPPER_LEVEL) {
	// Stackable. Level 0 and uppers are distinquished.
	const atr = lcl + '_attr_qual'
	// built in constants
	k(lcl, 'CONST_E')
	k(lcl, 'PI')
	k(lcl, 'SELF')
	c(lcl, 'INDET', '\\?') // Means: unspecified (e.g. for empty array slots).
	// built in functions
	k(lcl, 'ABS')
	k(lcl, 'ACOS')
	k(lcl, 'ASIN')
	k(lcl, 'ATAN')
	k(lcl, 'BLENGTH')
	k(lcl, 'COS')
	k(lcl, 'EXISTS')
	k(lcl, 'EXP')
	k(lcl, 'FORMAT')
	k(lcl, 'HIBOUND')
	k(lcl, 'HIINDEX')
	k(lcl, 'LENGTH')
	k(lcl, 'LOBOUND')
	k(lcl, 'LOINDEX')
	k(lcl, 'LOG')
	k(lcl, 'LOG2')
	k(lcl, 'LOG10')
	k(lcl, 'NVL')
	k(lcl, 'ODD')
	k(lcl, 'ROLESOF')
	k(lcl, 'SIN')
	k(lcl, 'SIZEOF')
	k(lcl, 'SQRT')
	k(lcl, 'TAN')
	k(lcl, 'TYPEOF')
	k(lcl, 'USEDIN')
	k(lcl, 'VALUE')
	k(lcl, 'VALUE_IN')
	k(lcl, 'VALUE_UNIQUE')
	// multiplication_like_op only DOUBLE_SOLID
	c(lcl, 'DOUBLE_SOLID', '\\|\\|')	// must be before SOLID
	// QUERY
	k(lcl, 'QUERY')
	c(lcl, 'LESS_ASTERISK', '<\\*') // must be before LE, NE
	c(lcl, 'SOLID', '\\|')
	// add_like_op - MINUS (and PLUS) must be before REAL and INT.
	c(lcl, 'PLUS', '\\+') // also used for unary_op
	c(lcl, 'MINUS', '-') // also used for unary_op
	k(lcl, 'OR')
	k(lcl, 'XOR')
	// Literals
	p(lcl, 'REAL_LIT', P_REAL_VALUE)
	p(lcl, 'INT', P_INT_VALUE)
	p(lcl, 'STR', P_STR_VALUE)
	p(lcl, 'BIN', P_BIN_VALUE)
	k(lcl, 'TRUE')
	k(lcl, 'FALSE')
	k(lcl, 'UNKNOWN')
	// rel_op_extended
	k(lcl, 'IN') // membership operator
	k(lcl, 'LIKE')
	// rel_op
	c(lcl, 'LE', '<=') // must be before LT
	c(lcl, 'NE', '<>') // must be before LT
	c(lcl, 'LT', '<')
	c(lcl, 'GE', '>=')
	c(lcl, 'GT', '>')
	c(lcl, 'EQ', '=')
	// exponentiation
	c(lcl, 'DOUBLE_ASTERISTK', '\\*\\*')
	// unary_op
	k(lcl, 'NOT')
	// multiplication_like_op (wo DOUBLE_SOLID)
	c(lcl, 'ASTERISK', '\\*')
	c(lcl, 'DIVIS', '/')
	k(lcl, 'DIV')
	k(lcl, 'MOD')
	k(lcl, 'AND')
	// Bracket controls
	c(lcl, 'COMMA', ',') // one or many expressions or elements or whatever are possible
	if (lcl == STT_EXPR_UPPER_LEVEL) {
		c(lcl, 'COLON', ':') // only inside aggregate_initializer and index_qualifier
		// No semicolon allowed.
	} else { // lcl == STT_EXPR
		c(lcl, 'COLON', ':', {pop: 1}) // pop out of expr for bound_spec .
		c(lcl, 'SEMI', ';', {pop: 1}) // pop out of expr for assignment or where.
	}
	c(lcl, 'LP', '\\(', {push: lcl}) // of same state
	c(lcl, 'RP', '\\)', {pop: 1})
	// scope
	//c(lcl, 'DLC', '\\{\\{', {push: lcl}) // of same state
	//c(lcl, 'DRC', '\\}\\}', {pop: 1})
	// interval
	c(lcl, 'LC', '\\{', {push: lcl}) // of same state
	c(lcl, 'RC', '\\}', {pop: 1})
	// attribute_qualifier and group_qualifier (we allow whitespace before)
	c(lcl, 'BACKSLASH', '\\\\')
	c(lcl, 'DOT', '\\.', {next:atr})
	p(atr, 'SIMPLE_ID', P_SIMPLE_ID, {next:lcl}) // only for attribute_qualifier (for enum value DIVERSE is not operation DIV but SIMPLE_ID)
	// aggregate_initializer and index_qualifier
	// index_qualifier ( [ idx0 : idx1 ] ) has no whitespace before, but an aggregate_initializer may have.
	c(lcl, 'LB', '\\[', {push: STT_EXPR_UPPER_LEVEL})
	c(lcl, 'RB', '\\]', {pop: 1})
	// any ids or refs
	p(lcl, 'SIMPLE_ID', P_SIMPLE_ID) // may be function_ref, entity_ref, type_ref, attribute_ref, ..
}


const P_SIMPLE_ID = '[a-zA-Z][a-zA-Z0-9_]*'

const P_REAL_VALUE = '[+-]?[0-9]+\\.[0-9]*(?:[eE][+-]?[0-9]+)?'
const P_INT_VALUE = '[+-]?[0-9]+'
//const P_STR_VALUE = "'(?:[^']| |'')*'"
const P_STR_VALUE = '\x27(?:[^\x27]| |\x27\x27)*\x27'
// string: {match: /"(?:\\["\\]|[^\n"\\])*"/, value: s => s.slice(1, -1)}
// See: https://github.com/no-context/moo#value-vs-text
const P_BIN_VALUE = '"[0-3][0-9A-F]*"'

sts['main'] = {}

sts['main']['WS'] = {match: /[ \t\n]+/, lineBreaks: true} // certain cases really need explicit whitespace

exprSs(STT_EXPR)
exprSs(STT_EXPR_UPPER_LEVEL)

const lexer = moo.states(sts)

function pNfo(token) {
	return {
		//value: token.value,
		line: token.line,
		col: token.col,
		offset: token.offset,
		lineBreaks: token.lineBreaks
	}
}

function toRlo(dd) {
	const raw = dd.type.toLowerCase()
	switch(raw) {
		case 'le': return 'le'
		case 'ge': return 'ge'
		case 'ne': return 'ne'
		case 'eq': return 'eq'
		case 'seq': return 'se'
		case 'sne': return 'sn'
		case 'lt': return 'lt'
		case 'gt': return 'gt'
		case 'in': return 'in'
		case 'like': return 'lik'
	}
	throw new Error(`Invalid relational operator "${raw}" error.`)
}

function toAdo(d) {
	const raw = d[0][0].type.toLowerCase()
	switch(raw) {
		case 'plus': return 'pls'
		case 'minus': return 'min'
		case 'or': return 'oor'
		case 'xor': return 'xor'
	}
	throw new Error(`Invalid addition/subtraction (or/xor) operator "${raw}" error.`)
}

function toMpo(d) {
	const raw = d[0][0].type.toLowerCase()
	switch(raw) {
		case 'asterisk': return 'ast'
		case 'divis': return 'dvs'
		case 'div': return 'div'
		case 'mod': return 'mod'
		case 'and': return 'and'
		case 'double_solid': return 'll2'
	}
	throw new Error(`Invalid multiplication/division (and and double solid) operator "${raw}" error.`)
}

function toUno(d) {
	const raw = d[0][0].type.toLowerCase()
	switch(raw) {
		case 'plus': return 'psu'
		case 'minus': return 'msu'
		case 'not': return 'not'
	}
	throw new Error(`Invalid unary operator "${raw}" error.`)
}

function toBic(d) {
	const raw = d[0][0].value
	switch(raw) {
		case 'const_e': return 'eul'
		case 'pi': return 'pii'
		case 'self': return 'slf'
		case '\\?': return 'idt'
		case 'true': return 'tru'
		case 'false': return 'fls'
		case 'unknown': return 'ukn'
	}
	throw new Error(`Invalid built in constant "${raw}" error.`)
}

function toBif(d) {
	const raw = d[0][0].value
	switch(raw) {
		case 'abs': return 'abs'
		case 'acos': return 'acs'
		case 'asin': return 'asn'
		case 'atan': return 'atn'
		case 'blength': return 'bln'
		case 'cos': return 'cos'
		case 'exists': return 'xst'
		case 'exp': return 'exp'
		case 'format': return 'fmt'
		case 'hibound': return 'hbd'
		case 'hiindex': return 'hdx'
		case 'length': return 'len'
		case 'lobound': return 'lbd'
		case 'loindex': return 'ldx'
		case 'log': return 'lgn'
		case 'log2': return 'lg2'
		case 'log10': return 'lgx'
		case 'nvl': return 'nvl'
		case 'odd': return 'odd'
		case 'rolesof': return 'rlf'
		case 'sin': return 'sin'
		case 'sizeof': return 'szf'
		case 'sqrt': return 'qrt'
		case 'tan': return 'tan'
		case 'typeof': return 'tpf'
		case 'usedin': return 'usd'
		case 'value': return 'vlu'
		case 'value_in': return 'vln'
		case 'value_unique': return 'vlq'
	}
	throw new Error(`Invalid built in function "${raw}" error.`)
}

function toArr(token, tName) {
	if (token && 0 < token.length) {
		return {t:tName, s:token}
	} else {
		return null
	}
}

function toNttRef(token) { // used for entity_ref only
	if (token && token.value) {
		return {t:'ntt_ref', id:token.value, p:pNfo(token)}
	} else {
		return null
	}
}

lexer.next = (next => () => {
    let tok
    while ((tok = next.call(lexer)) && (tok.type === 'WS')) {}
		//if (tok) { // Out the result from the lexer.
		//	console.log(tok.type, tok.value, lexer.stack, lexer.state)
		//}
    return tok
})(lexer.next)
let Lexer = lexer;
let ParserRules = [
    {"name": "main$ebnf$1", "symbols": [(lexer.has("WS") ? {type: "WS"} : WS)], "postprocess": id},
    {"name": "main$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main", "symbols": ["main$ebnf$1", "syntax"], "postprocess": d => d[1]},
    {"name": "expression$ebnf$1$subexpression$1", "symbols": ["rel_op_extended", "simple_expression"]},
    {"name": "expression$ebnf$1", "symbols": ["expression$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "expression$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "expression", "symbols": ["simple_expression", "expression$ebnf$1"], "postprocess": d => ({t:'xpr', arg0:d[0], op:(d[1]?d[1][0]:null), arg1:(d[1]?d[1][1]:null), p:pNfo(d[0]) })},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("LE") ? {type: "LE"} : LE)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("GE") ? {type: "GE"} : GE)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("NE") ? {type: "NE"} : NE)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("EQ") ? {type: "EQ"} : EQ)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("SEQ") ? {type: "SEQ"} : SEQ)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("SNE") ? {type: "SNE"} : SNE)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("LT") ? {type: "LT"} : LT)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("GT") ? {type: "GT"} : GT)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("IN") ? {type: "IN"} : IN)]},
    {"name": "rel_op_extended$subexpression$1", "symbols": [(lexer.has("LIKE") ? {type: "LIKE"} : LIKE)]},
    {"name": "rel_op_extended", "symbols": ["rel_op_extended$subexpression$1"], "postprocess": d => ({t:'o_sxp', id:toRlo(d[0][0]), p:pNfo(d[0])})},
    {"name": "simple_expression$ebnf$1", "symbols": []},
    {"name": "simple_expression$ebnf$1$subexpression$1", "symbols": ["add_like_op", "term"]},
    {"name": "simple_expression$ebnf$1", "symbols": ["simple_expression$ebnf$1", "simple_expression$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "simple_expression", "symbols": ["term", "simple_expression$ebnf$1"], "postprocess": d => toArr(d[1][0]?[d[0]].concat(...d[1]):[d[0]],'a_sxp_trms')},
    {"name": "add_like_op$subexpression$1", "symbols": [(lexer.has("PLUS") ? {type: "PLUS"} : PLUS)]},
    {"name": "add_like_op$subexpression$1", "symbols": [(lexer.has("MINUS") ? {type: "MINUS"} : MINUS)]},
    {"name": "add_like_op$subexpression$1", "symbols": [(lexer.has("OR") ? {type: "OR"} : OR)]},
    {"name": "add_like_op$subexpression$1", "symbols": [(lexer.has("XOR") ? {type: "XOR"} : XOR)]},
    {"name": "add_like_op", "symbols": ["add_like_op$subexpression$1"], "postprocess": d => ({t:'o_trm', id:toAdo(d), p:pNfo(d[0])})},
    {"name": "term$ebnf$1", "symbols": []},
    {"name": "term$ebnf$1$subexpression$1", "symbols": ["multiplication_like_op", "factor"]},
    {"name": "term$ebnf$1", "symbols": ["term$ebnf$1", "term$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "term", "symbols": ["factor", "term$ebnf$1"], "postprocess": d => toArr(d[1][0]?[d[0]].concat(...d[1]):[d[0]],'a_trm_ftrs')},
    {"name": "multiplication_like_op$subexpression$1", "symbols": [(lexer.has("ASTERISK") ? {type: "ASTERISK"} : ASTERISK)]},
    {"name": "multiplication_like_op$subexpression$1", "symbols": [(lexer.has("DIVIS") ? {type: "DIVIS"} : DIVIS)]},
    {"name": "multiplication_like_op$subexpression$1", "symbols": [(lexer.has("DIV") ? {type: "DIV"} : DIV)]},
    {"name": "multiplication_like_op$subexpression$1", "symbols": [(lexer.has("MOD") ? {type: "MOD"} : MOD)]},
    {"name": "multiplication_like_op$subexpression$1", "symbols": [(lexer.has("AND") ? {type: "AND"} : AND)]},
    {"name": "multiplication_like_op$subexpression$1", "symbols": [(lexer.has("DOUBLE_SOLID") ? {type: "DOUBLE_SOLID"} : DOUBLE_SOLID)]},
    {"name": "multiplication_like_op", "symbols": ["multiplication_like_op$subexpression$1"], "postprocess": d => ({t:'o_ftr', id:toMpo(d), p:pNfo(d[0])})},
    {"name": "factor$ebnf$1", "symbols": []},
    {"name": "factor$ebnf$1", "symbols": ["factor$ebnf$1", "qualifier"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "factor$ebnf$2$subexpression$1$ebnf$1", "symbols": []},
    {"name": "factor$ebnf$2$subexpression$1$ebnf$1", "symbols": ["factor$ebnf$2$subexpression$1$ebnf$1", "qualifier"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "factor$ebnf$2$subexpression$1", "symbols": [(lexer.has("DOUBLE_ASTERISTK") ? {type: "DOUBLE_ASTERISTK"} : DOUBLE_ASTERISTK), "simple_factor", "factor$ebnf$2$subexpression$1$ebnf$1"]},
    {"name": "factor$ebnf$2", "symbols": ["factor$ebnf$2$subexpression$1"], "postprocess": id},
    {"name": "factor$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "factor", "symbols": ["simple_factor", "factor$ebnf$1", "factor$ebnf$2"], "postprocess":  d => ({t:'ftr',
        	arg0:d[0][0], qals0:toArr(d[1], 'a_qals'),
        	arg1:(d[2]?d[2][1][0]:null), qals1:toArr((d[2]&&0<d[2][2].length?d[2][2]:null), 'a_qals'), p:pNfo(d[0])
        }) },
    {"name": "simple_factor", "symbols": ["literals"]},
    {"name": "simple_factor", "symbols": ["built_in_consts"]},
    {"name": "simple_factor", "symbols": ["query_expression"]},
    {"name": "simple_factor", "symbols": ["built_in_function_call"]},
    {"name": "simple_factor", "symbols": ["algorithm_call_or_entity_constructor"]},
    {"name": "simple_factor", "symbols": ["aggregate_initializer"]},
    {"name": "simple_factor", "symbols": ["interval"]},
    {"name": "simple_factor", "symbols": ["parenthesis_expr"]},
    {"name": "simple_factor", "symbols": ["unary_expr"]},
    {"name": "simple_factor", "symbols": ["any_ref"]},
    {"name": "parenthesis_expr", "symbols": [(lexer.has("LP") ? {type: "LP"} : LP), "expression", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => ({t:'par', xpr:d[1], p:pNfo(d[0])})},
    {"name": "unary_op$subexpression$1", "symbols": [(lexer.has("PLUS") ? {type: "PLUS"} : PLUS)]},
    {"name": "unary_op$subexpression$1", "symbols": [(lexer.has("MINUS") ? {type: "MINUS"} : MINUS)]},
    {"name": "unary_op$subexpression$1", "symbols": [(lexer.has("NOT") ? {type: "NOT"} : NOT)]},
    {"name": "unary_op", "symbols": ["unary_op$subexpression$1"], "postprocess": d => ({t:'o_uxp', id:toUno(d), p:pNfo(d[0])})},
    {"name": "unary_expr", "symbols": ["unary_op", "simple_factor"], "postprocess": d => ({t:'uxp', op:d[0], arg:d[1][0], p:pNfo(d[0])})},
    {"name": "literals", "symbols": [(lexer.has("REAL_LIT") ? {type: "REAL_LIT"} : REAL_LIT)], "postprocess": d => ({t:'rea', val:parseFloat(d[0].value), p:pNfo(d[0])})},
    {"name": "literals", "symbols": [(lexer.has("INT") ? {type: "INT"} : INT)], "postprocess": d => ({t:'int', val:parseInt(d[0].value), p:pNfo(d[0])})},
    {"name": "literals", "symbols": [(lexer.has("STR") ? {type: "STR"} : STR)], "postprocess": d => ({t:'str', val:convStr(d[0].value), p:pNfo(d[0])})},
    {"name": "literals", "symbols": [(lexer.has("BIN") ? {type: "BIN"} : BIN)], "postprocess": d => ({t:'bin', val:d[0].value, p:pNfo(d[0])})},
    {"name": "built_in_consts$subexpression$1", "symbols": [(lexer.has("CONST_E") ? {type: "CONST_E"} : CONST_E)]},
    {"name": "built_in_consts$subexpression$1", "symbols": [(lexer.has("PI") ? {type: "PI"} : PI)]},
    {"name": "built_in_consts$subexpression$1", "symbols": [(lexer.has("SELF") ? {type: "SELF"} : SELF)]},
    {"name": "built_in_consts$subexpression$1", "symbols": [(lexer.has("INDET") ? {type: "INDET"} : INDET)]},
    {"name": "built_in_consts$subexpression$1", "symbols": [(lexer.has("TRUE") ? {type: "TRUE"} : TRUE)]},
    {"name": "built_in_consts$subexpression$1", "symbols": [(lexer.has("FALSE") ? {type: "FALSE"} : FALSE)]},
    {"name": "built_in_consts$subexpression$1", "symbols": [(lexer.has("UNKNOWN") ? {type: "UNKNOWN"} : UNKNOWN)]},
    {"name": "built_in_consts", "symbols": ["built_in_consts$subexpression$1"], "postprocess": d => ({t:'bic', id:toBic(d), p:pNfo(d[0])})},
    {"name": "any_ref", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'any_ref', id:d[0].value, p:pNfo(d[0])})},
    {"name": "qualifier", "symbols": [(lexer.has("DOT") ? {type: "DOT"} : DOT), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'any_ref', id:d[1].value, p:pNfo(d[0])})},
    {"name": "qualifier", "symbols": [(lexer.has("BACKSLASH") ? {type: "BACKSLASH"} : BACKSLASH), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID)], "postprocess": d => ({t:'ntt_ref', id:d[1].value, p:pNfo(d[0])})},
    {"name": "qualifier$ebnf$1$subexpression$1", "symbols": [(lexer.has("COLON") ? {type: "COLON"} : COLON), "simple_expression"]},
    {"name": "qualifier$ebnf$1", "symbols": ["qualifier$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "qualifier$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "qualifier", "symbols": [(lexer.has("LB") ? {type: "LB"} : LB), "simple_expression", "qualifier$ebnf$1", (lexer.has("RB") ? {type: "RB"} : RB)], "postprocess": d => ({t:'idx_qal', fr:d[1], to:(d[2]?d[2]:null), p:pNfo(d[0]) })},
    {"name": "interval$subexpression$1", "symbols": [(lexer.has("LT") ? {type: "LT"} : LT)]},
    {"name": "interval$subexpression$1", "symbols": [(lexer.has("LE") ? {type: "LE"} : LE)]},
    {"name": "interval$subexpression$2", "symbols": [(lexer.has("LT") ? {type: "LT"} : LT)]},
    {"name": "interval$subexpression$2", "symbols": [(lexer.has("LE") ? {type: "LE"} : LE)]},
    {"name": "interval", "symbols": [(lexer.has("LC") ? {type: "LC"} : LC), "simple_expression", "interval$subexpression$1", "simple_expression", "interval$subexpression$2", "simple_expression", (lexer.has("RC") ? {type: "RC"} : RC)], "postprocess":  d => ({t:'itv',
        	arg0:d[1],
        	id1:toRlo(d[2][0]), arg1:d[3],
        	id2:toRlo(d[4][0]), arg2:d[5], p:pNfo(d[0])
        }) },
    {"name": "query_expression", "symbols": [(lexer.has("QUERY") ? {type: "QUERY"} : QUERY), (lexer.has("LP") ? {type: "LP"} : LP), (lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("LESS_ASTERISK") ? {type: "LESS_ASTERISK"} : LESS_ASTERISK), "simple_expression", (lexer.has("SOLID") ? {type: "SOLID"} : SOLID), "expression", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => ({t:'qry', var:d[2].value, src:d[4], cnd:d[6], p:pNfo(d[0]) })},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("ABS") ? {type: "ABS"} : ABS)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("ACOS") ? {type: "ACOS"} : ACOS)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("ASIN") ? {type: "ASIN"} : ASIN)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("ATAN") ? {type: "ATAN"} : ATAN)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("BLENGTH") ? {type: "BLENGTH"} : BLENGTH)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("COS") ? {type: "COS"} : COS)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("EXISTS") ? {type: "EXISTS"} : EXISTS)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("EXP") ? {type: "EXP"} : EXP)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("FORMAT") ? {type: "FORMAT"} : FORMAT)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("HIBOUND") ? {type: "HIBOUND"} : HIBOUND)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("HIINDEX") ? {type: "HIINDEX"} : HIINDEX)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("LENGTH") ? {type: "LENGTH"} : LENGTH)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("LOBOUND") ? {type: "LOBOUND"} : LOBOUND)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("LOINDEX") ? {type: "LOINDEX"} : LOINDEX)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("LOG") ? {type: "LOG"} : LOG)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("LOG2") ? {type: "LOG2"} : LOG2)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("LOG10") ? {type: "LOG10"} : LOG10)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("NVL") ? {type: "NVL"} : NVL)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("ODD") ? {type: "ODD"} : ODD)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("ROLESOF") ? {type: "ROLESOF"} : ROLESOF)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("SIN") ? {type: "SIN"} : SIN)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("SIZEOF") ? {type: "SIZEOF"} : SIZEOF)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("SQRT") ? {type: "SQRT"} : SQRT)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("TAN") ? {type: "TAN"} : TAN)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("TYPEOF") ? {type: "TYPEOF"} : TYPEOF)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("USEDIN") ? {type: "USEDIN"} : USEDIN)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("VALUE") ? {type: "VALUE"} : VALUE)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("VALUE_IN") ? {type: "VALUE_IN"} : VALUE_IN)]},
    {"name": "built_in_function_call$subexpression$1", "symbols": [(lexer.has("VALUE_UNIQUE") ? {type: "VALUE_UNIQUE"} : VALUE_UNIQUE)]},
    {"name": "built_in_function_call", "symbols": ["built_in_function_call$subexpression$1", (lexer.has("LP") ? {type: "LP"} : LP), "expr_list", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => ({t:'bif', id:toBif(d), vals:toArr(d[2],'a_bif_vals'), p:pNfo(d[0])})},
    {"name": "algorithm_call_or_entity_constructor$ebnf$1", "symbols": ["expr_list"], "postprocess": id},
    {"name": "algorithm_call_or_entity_constructor$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "algorithm_call_or_entity_constructor", "symbols": [(lexer.has("SIMPLE_ID") ? {type: "SIMPLE_ID"} : SIMPLE_ID), (lexer.has("LP") ? {type: "LP"} : LP), "algorithm_call_or_entity_constructor$ebnf$1", (lexer.has("RP") ? {type: "RP"} : RP)], "postprocess": d => ({t:'coc', ref:{t:'any_ref', id:d[0].value}, vals:toArr(d[2],'a_coc_vals'), p:pNfo(d[0])})},
    {"name": "expr_list$ebnf$1", "symbols": []},
    {"name": "expr_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("COMMA") ? {type: "COMMA"} : COMMA), "expression"]},
    {"name": "expr_list$ebnf$1", "symbols": ["expr_list$ebnf$1", "expr_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "expr_list", "symbols": ["expression", "expr_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "aggregate_initializer$ebnf$1", "symbols": ["elem_list"], "postprocess": id},
    {"name": "aggregate_initializer$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "aggregate_initializer", "symbols": [(lexer.has("LB") ? {type: "LB"} : LB), "aggregate_initializer$ebnf$1", (lexer.has("RB") ? {type: "RB"} : RB)], "postprocess": d => ({t:'agi', vals:toArr(d[1],'a_agi_elts'), p:pNfo(d[0])})},
    {"name": "elem_list$ebnf$1", "symbols": []},
    {"name": "elem_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("COMMA") ? {type: "COMMA"} : COMMA), "element"]},
    {"name": "elem_list$ebnf$1", "symbols": ["elem_list$ebnf$1", "elem_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "elem_list", "symbols": ["element", "elem_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "element$ebnf$1$subexpression$1", "symbols": [(lexer.has("COLON") ? {type: "COLON"} : COLON), "simple_expression"]},
    {"name": "element$ebnf$1", "symbols": ["element$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "element$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "element", "symbols": ["expression", "element$ebnf$1"], "postprocess": d => ({t:'elt', arg:d[0], mlt:(d[1]?d[1][1]:null), p:pNfo(d[0]) })},
    {"name": "entity_ref_list$ebnf$1", "symbols": []},
    {"name": "entity_ref_list$ebnf$1$subexpression$1", "symbols": [(lexer.has("COMMA") ? {type: "COMMA"} : COMMA), "entity_ref"]},
    {"name": "entity_ref_list$ebnf$1", "symbols": ["entity_ref_list$ebnf$1", "entity_ref_list$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "entity_ref_list", "symbols": ["entity_ref", "entity_ref_list$ebnf$1"], "postprocess": d => d[1][0]?[d[0]].concat(d[1].map(e=>e.slice(1)[0]) ):[d[0]]},
    {"name": "entity_ref", "symbols": [(lexer.has("ENTITY_REF") ? {type: "ENTITY_REF"} : ENTITY_REF)], "postprocess": d => toNttRef(d[0])},
    {"name": "syntax", "symbols": ["expression"], "postprocess": d => d[0]}
];
let ParserStart = "main";
export default { Lexer, ParserRules, ParserStart };
